import axios from 'axios'
import { AUTH_SERVICE_URL, } from '../helper/constant'
import { cacheService } from '../helper/utils'
import { PORTAL_INSTANCE } from '..'
import { userEventsChecker } from '../helper/user-session-handler'

const loginInterface = {
    'username': 'username',
    'password': 'password',
    'portalId': 'portalId',
    'clientId': 'clientId',
    'option': 'option',
    'isLoginByCentralUrl': 'isLoginByCentralUrl'
}

const getLoginParams = ({ username, password, portalId, clientId, option, isLoginByCentralUrl }) => {
    if (portalId && typeof portalId != 'number') {
        portalId = parseInt(portalId)
    }
    if (clientId && typeof clientId != 'number') {
        clientId = parseInt(clientId)
    }
    return {
        [loginInterface['username']]: username,
        [loginInterface['password']]: password,
        [loginInterface['portalId']]: portalId,
        [loginInterface['clientId']]: clientId,
        [loginInterface['option']]: option,
        [loginInterface['isLoginByCentralUrl']]: isLoginByCentralUrl
    }
}

export const REPORTS = {
    DISPLAY: 'Reports Display',
    SEARCH: 'Reports Search',
    RECEPTION: 'Reception Reports',
    BOOKING: 'Booking Reports',
    REVENUE_SHARE: 'Revenue Share Reports',
    VALUE_BACK: 'Value Back Reports',
    SERVICEFEE_BOOKING: 'ServiceFee Booking Reports',
    MISCELLANEOUS: 'Miscellaneous Reports',
    PORTAL_DOCS: 'Portal Docs'
}

class Auth {
    static portalId
    static clientId
    static clientName
    static portalName

    static _userInfo
    static _rights

    static userId
    static username
    static email
    static phone
    static fullName
    static firstName
    static lastName

    //Supervisor Assigned User: (Access all collection requests for assigned users and countries)
    static isSupervisor
    //All Users: (Access all collection requests for assigned countries)
    static isRequestManager
    //Client Portal: User Management
    static isSuperUser
    //Admin Portal: Admin User
    static isAdminUser

    //other roles --> need to be removed
    static isReports
    static isVisualReport
    static isQRGenerater
    static isDashboardView
    static isPalletDashboardView
    static isNewReqSum
    static importRequest
    static isNewReq
    static isPortalDoc
    static isCircleDoc
    static isCollectionAddress
    static isCompanies
    static isRecursiveRequest
    static isRequestDocs

    static culture
    static cultureId
    static userCountryCode
    static userCountryShortcut
    static UOMmultiplier

    static reqTypes = [];
    static countries = [];
    static reportModule = [];

    static moduleIds = []

    static isLoadPortalUID

    static logoutFn;

    static isLoginByCentralUrl
    static isPasswordExpired

    static isUserSessionExpired
    static MAX_LEFT_TIME = 30 * 60 * 1000;//30 minutes

    static _clearUserProps() {
        //default value of request
        this.portalId = PORTAL_INSTANCE.pId
        this.clientId = PORTAL_INSTANCE.cId

        this._userInfo = undefined
        this._rights = {}

        this.clientName = undefined
        this.portalName = undefined
        this.userId = undefined
        this.username = undefined
        this.email = undefined
        this.phone = undefined
        this.fullName = undefined
        this.firstName = undefined
        this.lastName = undefined

        this.isSupervisor = false
        this.isRequestManager = false

        this.isSuperUser = false
        this.isAdminUser = false

        this.isReports = false
        this.isVisualReport = false
        this.isQRGenerater = false

        this.isDashboardView = false
        this.isPalletDashboardView = false
        this.isNewReqSum = false
        this.isNewReq = false
        this.isPortalDoc = false
        this.isCircleDoc = false
        this.importRequest = undefined
        this.isCollectionAddress = false
        this.isCompanies = false
        this.isRecursiveRequest = false
        this.isRequestDocs = false

        this.cultureId = undefined
        this.culture = { name: 'English', shortCut: 'en-US' }
        this.userCountryCode = undefined

        this.moduleIds = []
        this.isLoadPortalUID = false

        this.isLoginByCentralUrl = false
        this.isPasswordExpired = false
    }

    static _clearUserCache() {
        //console.log('Token Cache clear')
        const pkey = `${PORTAL_INSTANCE.pkey}${this.portalId}_`
        cacheService.removeCache(pkey)
        cacheService.removeCache(PORTAL_INSTANCE.ekey)
        cacheService.removeCache(`${PORTAL_INSTANCE.ekey}${Auth.userId}_utoken`)
        cacheService.removeCache(`${PORTAL_INSTANCE.ekey}${Auth.userId}_urights`)
        cacheService.removeCache(`${PORTAL_INSTANCE.ekey}${Auth.userId}_userGroupConfig`)
        cacheService.removeCache('reqTypes')
        cacheService.removeCache('countries')
        cacheService.removeCache('reportModule')
        cacheService.removeCache('releaseVersion')
        cacheService.removeCache('releaseVersionShown')
        cacheService.removeCache('userCountryShortcut')
        cacheService.removeCache('UOMMultiplier')
    }

    static setUserData(userInfo) {
        let { token, refreshTK } = userInfo
        if (token && !isJWTTokenExpired(token)) {
            console.log('--------------------------------Portal-Auth set User-----------------------------')
            this._userInfo = JSON.parse(JSON.stringify(userInfo))
            let decoded = jwtBase64URLdecode(userInfo.token)
            let decodedRTK = jwtBase64URLdecode(userInfo.refreshTK)
            Object.assign(this, this._userInfo)
            //caching data
            const pkey = `${PORTAL_INSTANCE.pkey}${userInfo.portalId}_`
            cacheService.setCache(pkey, this._userInfo)
            cacheService.setCache(PORTAL_INSTANCE.ekey, this._userInfo)

            cacheService.setCache(`${PORTAL_INSTANCE.ekey}${Auth.userId}_utoken`, {
                token, refreshTK,
                expiry: new Date(decoded.exp * 1000),
                created: new Date(decoded.iat * 1000),
                expiryRTK: new Date(decodedRTK.exp * 1000),
                createdRTK: new Date(decodedRTK.iat * 1000),
            });

            if (!this.isSupervisor && this.isRequestManager) {
                this.isSupervisor = true;
            }

            if (userInfo.clientId && typeof userInfo.clientId != 'number') {
                this._userInfo.clientId = userInfo.clientId = parseInt(userInfo.clientId)
            }
            if (userInfo.portalId && typeof userInfo.portalId != 'number') {
                this._userInfo.portalId = userInfo.portalId = parseInt(userInfo.portalId)
            }
            //set user portal if changed
            let { cId, pId } = PORTAL_INSTANCE
            if (!(cId === userInfo.clientId && pId === userInfo.portalId)) {
                PORTAL_INSTANCE.cId = userInfo.clientId
                PORTAL_INSTANCE.pId = userInfo.portalId
            }

            userEventsChecker.registerEvents(Auth)
        }
    }

    static initialize() {
        console.log('--------------------------------Portal-Auth initialize-----------------------------')
        this._clearUserProps();
        let userInfo = cacheService.getCache(PORTAL_INSTANCE.ekey) || {};
        console.log(PORTAL_INSTANCE.ekey, (userInfo && userInfo.userId))
        this.setUserData(userInfo)

        if (this.token && !this.isTokenExpired) {
            let userRights = cacheService.getCache(`${PORTAL_INSTANCE.ekey}${Auth.userId}_urights`)
            this.setUserRights(userRights || {})
            let portalConfigInfo = cacheService.getCache(`${PORTAL_INSTANCE.ekey}${Auth.userId}_userGroupConfig`)
            this.setUserConfigData(portalConfigInfo || {})
        }
    }

    static set token(t) {
    }
    static set expiry(t) {
    }
    static set refreshTK(t) {
    }
    static set expiryRTK(t) {
    }
    static getUToken(field) {
        if (!Auth.userId) return ''
        let utoken = cacheService.getCache(`${PORTAL_INSTANCE.ekey}${Auth.userId}_utoken`) || this._userInfo
        return (utoken && utoken[field]) || ''
    }
    static get token() {
        return this.getUToken('token')
    }
    static get expiry() {
        let expiry = this.getUToken('expiry')
        return expiry ? new Date(expiry) : 0
    }
    static get refreshTK() {
        return this.getUToken('refreshTK')
    }
    static get expiryRTK() {
        let expiry = this.getUToken('expiryRTK')
        return expiry ? new Date(expiry) : 0
    }

    static get isTokenExpired() {
        let { token, expiry } = this
        let now = new Date()
        if (token && expiry) {
            let isExpired = ((expiry.getTime() - now.getTime()) <= 0)
            return isExpired
        }
        return false;
    }

    static get isTokenAboutToExpire() {
        let { token, expiry } = this
        let now = new Date()
        if (token && expiry) {
            let gapExpiry = 10 * 60 * 1000//less than 10 minute
            let isExpired = (expiry.getTime() - now.getTime()) <= gapExpiry
            return isExpired
        }
        return false;
    }
    static get isRefreshTKExpired() {
        let { refreshTK: token, expiryRTK: expiry } = this
        let now = new Date()
        if (token && expiry) {
            let isExpired = ((expiry.getTime() - now.getTime()) <= 0)
            return isExpired
        }
        return false;
    }

    static get isUserAuthenticated() {
        return (this.token && !this.isTokenExpired);
    }

    static async loginWithUserNameAndPassword(args) {
        console.log('--------------------------------loginWithUserNameAndPassword-----------------------------')
        this._clearUserCache();
        let headers = {
            "Content-Type": "application/json"
        }
        const LOGIN_URL = `${AUTH_SERVICE_URL}${args.option ? '/portal/loginByScanningQR' : '/portal/login'}`;

        let loginPayloadArgs = getLoginParams(args);
        if (args.adminToken) loginPayloadArgs.adminToken = args.adminToken;
        // if (args.adminUserId) loginPayloadArgs.adminUserId = args.adminUserId;
        // if (args.fname) loginPayloadArgs.fname = args.fname;

        const { data } = await axios.post(LOGIN_URL, loginPayloadArgs, { headers })
        const userData = data.data
        if (userData) {
            this.setUserData(userData);
        }
        return userData || data
    }

    static async verifyUserMFA(args) {
        console.log('--------------------------------verifyUserMFA-----------------------------')
        this._clearUserCache();
        let headers = {
            "Content-Type": "application/json"
        }
        const VERIFY_URL = `${AUTH_SERVICE_URL}/portal/loginMFAVerify`
        const { data } = await axios.post(VERIFY_URL, args, { headers })
        const userData = data.data
        if (userData) {
            this.setUserData(userData);
        }
        return userData || data
    }

    static async loginWithAdminToken(payload) {
        console.log('--------------------------------loginWithAdminToken-----------------------------')
        this._clearUserCache();
        let { token, userId, userType, cId, pId, portalType } = payload
        let headers = {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
            "x-userId": userId,
            "x-portal": pId,
        }
        const LOGIN_URL = `${AUTH_SERVICE_URL}/portal/loginWithAdminToken`;

        const { data } = await axios.post(LOGIN_URL, { userId, userType, clientId: cId, portalId: pId, portalType }, { headers })
        const userData = data.data
        if (userData) {
            this.setUserData(userData);
        }
        return userData || data
    }

    static logout() {
        console.log('--------------------------------logout-----------------------------')
        this._clearUserProps();
        this._clearUserCache();
        userEventsChecker.clearSessionEvent()
    }

    static doLogout() {
        try {
            this.logoutFn && this.logoutFn()
        } catch (error) {
        }
        this.logout()
    }

    static subscribeTokenExpiry(fn) {
        this.logoutFn = fn;
    }

    static setUserGroup(data = []) {
        let reqTypes = [];
        let countries = [];
        let reportModule = [];

        let rights = {}

        let portalConfigInfo = {}

        if (data.length) {
            this.isLoadPortalUID = true
            data.forEach(grMapping => {
                if (grMapping.reqTypeInfo && grMapping.reqTypeInfo.length) {
                    grMapping.reqTypeInfo.forEach(reqType => {
                        reqTypes.push(reqType.reqTypeId);
                    })
                }
                if (grMapping.countryInfo && grMapping.countryInfo.length) {
                    grMapping.countryInfo.forEach(c => {
                        countries.push(c.countryId);
                    })
                }
                if (grMapping.moduleInfo && grMapping.moduleInfo.length) {
                    grMapping.moduleInfo.forEach(md => {
                        if (md && md.moduleInfo) {
                            reportModule.push(md.moduleInfo.name);

                        }
                    })
                }
                if (grMapping.rights) {
                    rights = grMapping.rights
                }
                if (grMapping.portalConfigInfo.length) {
                    portalConfigInfo = grMapping.portalConfigInfo[0]
                }
            })
        }

        this.reqTypes = reqTypes;
        this.countries = countries;
        this.reportModule = reportModule;

        cacheService.setCache('reqTypes', reqTypes)
        cacheService.setCache('countries', countries)
        cacheService.setCache('reportModule', reportModule)
        cacheService.setCache(`${PORTAL_INSTANCE.ekey}${Auth.userId}_urights`, rights)
        cacheService.setCache(`${PORTAL_INSTANCE.ekey}${Auth.userId}_userGroupConfig`, portalConfigInfo)

        this.setUserRights(rights)
        this.setUserConfigData(portalConfigInfo)
    }

    static setUserCountryShortCut(countryCode) {
        cacheService.setCache('userCountryShortcut', (countryCode || 'SG').toUpperCase())
    }

    static getUserCountryShortCut() {
        return cacheService.getCache('userCountryShortcut') || 'SG'
    }

    static setUOMMultiplier(data) {
        let multiplier = parseFloat(data.multiplier);
        if (isNaN(multiplier)) {
            multiplier = 1;
        }
        if (!data.uom) data.uom = 'cm';
        data.multiplier = multiplier;
        cacheService.setCache('UOMMultiplier', data)
    }

    static getUOMMultiplier() {
        let result = 1;
        let resultData = cacheService.getCache('UOMMultiplier');
        if (resultData && resultData.multiplier) {
            result = resultData.multiplier
        }
        return result;
    }

    static getUOMName() {
        let result = 'cm';
        let resultData = cacheService.getCache('UOMMultiplier');
        if (resultData && resultData.uom) {
            result = resultData.uom
        }
        return result;
    }

    static getUserGroup() {
        const _reqTypes = cacheService.getCache('reqTypes') || [];
        const _countries = cacheService.getCache('countries') || [];
        const _reportModule = cacheService.getCache('reportModule') || [];

        this.reqTypes = this.reqTypes.length ? this.reqTypes : _reqTypes;
        this.countries = this.countries.length ? this.countries : _countries;
        this.reportModule = this.reportModule.length ? this.reportModule : _reportModule;
        return {
            reqTypes: this.reqTypes,
            countries: this.countries,
            reportModule: this.reportModule,
        }
    }

    static isHasReport(report = '') {
        if (!report || !this.reportModule.length) return false;
        report = report.toString().replace(/ /g, '').toUpperCase();
        let result = this.reportModule.find(rp => rp.toString().replace(/ /g, '').toUpperCase() === report);
        return result;
    }

    static hasRight(key, type) {
        if (!Auth._rights) {
            return false
        }
        let right = Auth._rights[key]
        if (!right) {
            return false
        }
        let permis = right[type]
        return (permis ? true : false)
    }
    static hasRightView(key) {
        return Auth.hasRight(key, 'isRead')
    }
    static hasRightAdd(key) {
        return Auth.hasRight(key, 'isWrite')
    }
    static hasRightChange(key) {
        return Auth.hasRight(key, 'isChange')
    }
    static hasRightDelete(key) {
        return Auth.hasRight(key, 'isDelete')
    }

    static setUserRights(rights = {}) {
        console.log('--------------------------------Portal-Auth setUserRights-----------------------------', rights)
        this._rights = rights

        //hasRightAdd
        this.isNewReq = this.hasRightAdd('REQUEST_LIST')
        this.importRequest = this.hasRightAdd('REQUEST_LIST')
        this.isNewReqSum = this.hasRightAdd('DAS_REQUEST_SUM')

        //support older version with permission/rights
        this.isDashboardView = this.hasRightView('DASHBOARD')
        this.isPalletDashboardView = this.hasRightView('DASHBOARD')

        this.isRecursiveRequest = this.hasRightView('REC_REQUEST_LIST')

        this.isRequestDocs = this.hasRightView('DOC_STANDARD')
        this.isCircleDoc = this.hasRightView('DOC_SERVICE')
        this.isPortalDoc = this.hasRightView('DOC_OTHER')

        this.isCollectionAddress = this.hasRightView('MASTER_DATA')
        this.isCompanies = this.hasRightView('MASTER_DATA')
    }

    static setUserConfigData(portalConfigData = {}) {
        console.log('--------------------------------Portal-Auth setUserConfigData-----------------------------', portalConfigData)
        let fieldMap = [
            // { "authField": "isDashboardView", "field": "isDashboardView" },
            // { "authField": "isPalletDashboardView", "field": "isPalletDashboardView" },
            // { "authField": "isReqSumView", "field": "isReqSumView" },
            // { "authField": "isNewReqView", "field": "isNewReqView" },
            // { "authField": "isPortalDoc", "field": "isPortalDoc" },
            // { "authField": "isCircleDoc", "field": "isCircleDoc" },
            // { "authField": "isCollectionAddress", "field": "isCollectionAddress" },
            // //
            // { "authField": "isQRGenerater", "field": "isQRCodeGen" },
            // { "authField": "isVisualReport", "field": "isVisualReport" },
            // { "authField": "importRequest", "field": "importRequest" },
            // { "authField": "isCompanies", "field": "isCompanies" },
            // { "authField": "isRecursiveRequest", "field": "isRecursiveRequest" },
            // { "authField": "isRequestDocs", "field": "isRequestDocs" },
            //
            { "authField": "moduleIds", "field": "moduleIds", "type": "object" },
        ]
        let _self = this
        for (let k of fieldMap) {
            let v = portalConfigData[k.field]
            if (k.type === "object") {
                _self[k.authField] = v
            } else {
                _self[k.authField] = v ? true : false
            }
        }

        // this.isSuperUser = (portalConfigData['isSuperUser'] || this.isSuperUser) ? true : false
        if (!Array.isArray(this.moduleIds)) this.moduleIds = []
    }

    //refreshToken
    static async refreshAuthJWT() {
        // console.log('--------------------------------refreshAuthJWT-----------------------------')
        let { refreshTK, portalId, userId } = this
        if (!(userId && portalId && refreshTK)) {
            console.log('Having NO user profile and refresh token!')
            return
        }

        let isExpired = Auth.isRefreshTKExpired || isJWTTokenExpired(refreshTK)
        if (isExpired) {
            console.log('Refresh token NOT exists or Already expired!')
            return
        }

        const URL = `${AUTH_SERVICE_URL}/portal/refreshToken`;
        let headers = {
            "x-userid": this.userId,
        }

        const { data } = await axios.post(URL, { refreshTK, portalId, userId }, { headers });
        const userData = data.data
        if (userData) {
            this.setUserData(userData);
        }
        return userData || data
    }
}

export function isJWTTokenExpired(token, gapTime = 0) {
    if (!token) {
        return true
    }
    let decoded = jwtBase64URLdecode(token)
    if (!(decoded && decoded.exp && decoded.iat)) {
        return true
    }

    let now = new Date()
    let expiry = new Date(decoded.exp * 1000)
    return ((expiry.getTime() - now.getTime() - gapTime) <= 0)
}

export function jwtBase64URLencode(str) {
    const utf8Arr = new TextEncoder().encode(str);
    const base64Encoded = window.btoa(utf8Arr);
    return base64Encoded.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
export function jwtBase64URLdecode(str) {
    let vals = str.split('.')
    str = vals[1]
    if (vals.length !== 3 && str) {
        return
    }
    const base64Encoded = str.replace(/-/g, '+').replace(/_/g, '/');
    const padding = str.length % 4 === 0 ? '' : '='.repeat(4 - (str.length % 4));
    const base64WithPadding = base64Encoded + padding;
    const result = window.atob(base64WithPadding)
        .split('')
        .map(char => String.fromCharCode(char.charCodeAt(0))).join('')
    return JSON.parse(result);
}

export default Auth;



